export default __webpack_public_path__ + "static/media/hospitalSign.1c18f63d.svg";